import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../translate';

@Component({
  selector: 'wego-confirm-popup',
  template: `
  <div bsModal #confirmModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{{ popupTitle }}</h4>
            </div>
            <div class="modal-body">
                {{ popupMsg }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-green" (click)="Confirm($event)">{{ 'LblYes' | translate }}</button>
                <button type="button" class="btn btn-gray" (click)="Reject($event)">{{ 'LblNo' | translate }}</button>
            </div>
        </div>
    </div>
  </div>`
})

export class ConfirmPopupComponent implements OnInit, OnDestroy {
  _popupTitle: string = this.translate.instant('LblConfirm');
  _popupMsg: string = this.translate.instant('LblRecordDeleteConfirmation');

  @ViewChild('confirmModal') public confirmModal: ModalDirective;

  @Input()
  set popupMsg(popupMsg: string) {
    this._popupMsg = (popupMsg && popupMsg.trim()) || this.translate.instant('LblRecordDeleteConfirmation');
  }
  get popupMsg() { return this._popupMsg; }

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblConfirm');
  }
  get popupTitle() { return this._popupTitle; }

  @Output('onConfirm') onConfirm = new EventEmitter();
  @Output('onReject') onReject = new EventEmitter();


  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  public show() {
    this.confirmModal.show();
  }

  public hide() {
    this.confirmModal.hide();
  }

  private Confirm($event: any) {
    this.onConfirm.emit($event);
  }

  private Reject($event: any) {
    this.onReject.emit($event);
  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/popup/confirm-popup.component.ts